var TERTIARY_FONTS = {
  headerFont: "'Skintype Display', 'Century Gothic', CenturyGothic, AppleGothic, Verdana, sans-serif",
  baseFont: "'atkinson-hyperlegible', sans-serif",
  monoFont: "'apercu mono', 'Lucida Console', Monaco, monospace"
};

export { TERTIARY_FONTS as default };
